import React from 'react';
import { recipesData } from '../../data/regionalChef/recipesData'; // ดึงข้อมูลชื่อเมนูอาหารมาใช้

// ฐานข้อมูลสัญลักษณ์ของวัตถุดิบแต่ละประเภท
const ingredientData = {
  // วัตถุดิบดิบ (อ้างอิงตามภาพ)
  'raw_pork': { icon: '🥩', name: 'หมูชิ้น' },
  'raw_chicken': { icon: '🍗', name: 'ไก่สด' },
  'raw_shrimp': { icon: '🦐', name: 'กุ้งสด' },
  'raw_egg': { icon: '🥚', name: 'ไข่ไก่' },
  'raw_papaya': { icon: '🥒', name: 'มะละกอ' },
  'raw_chili': { icon: '🌶️', name: 'พริกสด' },
  'raw_garlic': { icon: '🧄', name: 'กระเทียม' },
  'raw_curry_herbs': { icon: '🌿', name: 'สมุนไพรแกง' },
  'raw_tomato': { icon: '🍅', name: 'มะเขือเทศ' },
  'raw_sato': { icon: '🫘', name: 'สะตอ' },
  'raw_noodles': { icon: '🍜', name: 'เส้นต่างๆ' },

  // วัตถุดิบที่ผ่านการแปรรูปแล้ว 1 ขั้น
  'processed_minced_pork': { icon: '🥩🔪', name: 'หมูสับ' },
  'processed_grilled_pork': { icon: '🍖', name: 'หมูย่าง' },
  'processed_papaya_shreds': { icon: '🥗', name: 'เส้นมะละกอ' },
  'processed_beaten_egg': { icon: '🥣🥚', name: 'ไข่เจียวดิบ' },
  'processed_chili_garlic': { icon: '🧄🌶️', name: 'พริกกระเทียมโขลก' },
  'processed_curry_paste': { icon: '🥣🌿', name: 'พริกแกง' },
};

const Card = ({ type, isSelected, onClick }) => {
  let icon = '❓'; // ไอคอนเริ่มต้น (ถ้าหาไม่เจอ)
  let displayName = type;
  let cardBg = 'white';

  // ตรวจสอบว่าเป็นวัตถุดิบ หรือ เมนูอาหาร
  if (ingredientData[type]) {
    icon = ingredientData[type].icon;
    displayName = ingredientData[type].name;
  } else if (type && type.startsWith('recipe_')) {
    icon = '🍽️'; // สัญลักษณ์เมนูอาหารที่ปรุงเสร็จแล้ว
    cardBg = '#fff9e6'; // ไฮไลท์สีพื้นหลังการ์ดอาหารให้ต่างจากวัตถุดิบ
    if (recipesData[type]) {
      displayName = recipesData[type].name;
    }
  }

  return (
    <div
      onClick={onClick}
      style={{
        width: '100px',
        height: '140px',
        backgroundColor: cardBg,
        border: isSelected ? '3px solid #3742fa' : '2px solid #dfe4ea',
        borderRadius: '12px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        boxShadow: isSelected ? '0 8px 15px rgba(55, 66, 250, 0.3)' : '0 4px 6px rgba(0,0,0,0.05)',
        transform: isSelected ? 'translateY(-10px)' : 'translateY(0)', // เด้งขึ้นเมื่อถูกคลิกเลือก
        transition: 'all 0.2s ease-in-out',
        padding: '10px',
        boxSizing: 'border-box',
        position: 'relative'
      }}
    >
      <div style={{ fontSize: '40px', marginBottom: '10px' }}>
        {icon}
      </div>
      
      <div style={{ 
        fontSize: '13px', 
        fontWeight: 'bold', 
        textAlign: 'center', 
        color: '#2f3542',
        lineHeight: '1.2'
      }}>
        {displayName}
      </div>

      {/* เพิ่มจุดสังเกตเล็กๆ มุมขวาบน ถ้าเป็นเมนูพร้อมเสิร์ฟ */}
      {type && type.startsWith('recipe_') && (
        <div style={{
          position: 'absolute',
          top: '-5px',
          right: '-5px',
          backgroundColor: '#2ed573',
          color: 'white',
          borderRadius: '50%',
          width: '20px',
          height: '20px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '12px'
        }}>
          ✨
        </div>
      )}
    </div>
  );
};

export default Card;